import React from "react";
import { Link } from "react-router-dom";
import { Clock, CheckCircle2, CalendarDays } from "lucide-react";
import OfflineItemBadge from "../../../components/OfflineItemBadge";

function formatTime(t) {
  if (!t) return null;
  const m = t.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return null;
  const h = parseInt(m[1], 10);
  return `${h % 12 || 12}:${m[2]} ${h >= 12 ? "PM" : "AM"}`;
}

const STATUS_CONFIG = {
  pendiente:    { icon: Clock,        iconCls: "text-amber-600 dark:text-amber-400",     bgCls: "bg-amber-100 dark:bg-amber-900/30"     },
  _overdue:     { icon: Clock,        iconCls: "text-amber-700 dark:text-amber-300",     bgCls: "bg-amber-200/70 dark:bg-amber-900/50"  },
  realizada:    { icon: CheckCircle2, iconCls: "text-emerald-600 dark:text-emerald-400", bgCls: "bg-emerald-50 dark:bg-emerald-900/20"  },
  reprogramada: { icon: CalendarDays, iconCls: "text-blue-500 dark:text-blue-400",       bgCls: "bg-blue-50 dark:bg-blue-900/20"        },
  cancelada:    { icon: Clock,        iconCls: "text-slate-400 dark:text-slate-500",     bgCls: "bg-slate-100 dark:bg-slate-700/30"     },
};

const _today = new Date();
_today.setHours(0, 0, 0, 0);

export default function VisitRowCard({ visit }) {
  const dateObj   = visit.date ? new Date(visit.date + "T00:00:00") : null;
  const isOverdue = visit.status === "pendiente" && dateObj && dateObj < _today;
  const cfg       = STATUS_CONFIG[isOverdue ? "_overdue" : visit.status] || STATUS_CONFIG.pendiente;
  const Icon      = cfg.icon;
  const time      = formatTime(visit.time);

  return (
    <Link
      to={`/visits/${visit.id}`}
      className="flex items-center gap-3.5 bg-white dark:bg-slate-800
                 rounded-[24px] border border-slate-200/50 dark:border-slate-700/50
                 shadow-[0_2px_12px_rgba(0,0,0,0.03)]
                 transition-all duration-300 ease-out
                 hover:shadow-[0_8px_24px_rgba(0,0,0,0.06)]
                 active:scale-[0.98] active:opacity-80 overflow-hidden"
    >
      {dateObj && (
        <div className="flex flex-col items-center justify-center w-14 py-3.5 pl-4 shrink-0">
          <span className="text-[9px] font-bold uppercase text-slate-400 dark:text-slate-500 leading-none">
            {dateObj.toLocaleDateString("es-MX", { month: "short" }).replace(".", "")}
          </span>
          <span className="text-[22px] font-bold text-slate-900 dark:text-slate-100 leading-tight">
            {dateObj.getDate()}
          </span>
        </div>
      )}
      <div className="w-px self-stretch bg-slate-100 dark:bg-slate-700/60 my-3 shrink-0" />
      <div className="flex-1 min-w-0 py-3.5">
        <p className="text-[14px] font-semibold text-slate-900 dark:text-slate-100 truncate leading-snug">
          {visit.contact_name || "Sin nombre"}
        </p>
        {(visit.churchName || time) && (
          <p className="text-[11px] text-slate-400 dark:text-slate-500 mt-0.5 truncate leading-none">
            {[time, visit.churchName].filter(Boolean).join(" · ")}
          </p>
        )}
      </div>
      <OfflineItemBadge item={visit} />
      <div className={`h-11 w-11 rounded-[12px] flex items-center justify-center shrink-0 mr-4 ${cfg.bgCls}`}>
        <Icon size={16} className={cfg.iconCls} strokeWidth={2} />
      </div>
    </Link>
  );
}
